import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, LinkedinIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { navigation, profile } from '../data/profile';
import { GridIcon, PipelineIcon, NeuralIcon, WaterIcon } from './IndustryIcons';
type LayoutProps = {
  children: React.ReactNode;
};
export function Layout({
  children
}: LayoutProps) {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  React.useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <div className="canvas-sheet flex min-h-screen w-full flex-col" data-id="element-62" data-mp="27j6ifb2ewtv">
      <a href="#sheet" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-panel focus:px-4 focus:py-2 focus:text-steel-dark" data-id="element-63" data-mp="gzbn0umligx6">
        Skip to content
      </a>

      <header className="sticky top-0 z-40 border-b border-white/10 bg-ink/95 backdrop-blur" data-id="element-64" data-mp="3km26usgus2tt">
        <div className="mx-auto flex max-w-sheet items-center justify-between gap-6 px-5 py-3 sm:px-8" data-id="element-65" data-mp="3fnqxsjydtwcn">
          <Link to="/" className="group flex items-center gap-3" data-id="element-66" data-mp="1irnhe9yjb4ok">
            <span className="flex h-10 w-10 items-center justify-center border border-copper text-copper-light" data-id="element-67" data-mp="1msyyts798jlo">
              <span className="display text-sm font-black" data-id="element-68" data-mp="1rlidytllbmsl">DL</span>
            </span>
            <span className="leading-tight" data-id="element-69" data-mp="1wjtl2wki3j74">
              <span className="display block text-sm font-black tracking-tight text-panel" data-id="element-70" data-mp="1wisdj22p1eu5">David Lukcic, P.E., MBA</span>
              <span className="block text-[10px] font-semibold uppercase tracking-[0.22em] text-hydro-light" data-id="element-71" data-mp="13uwfnu1e1gvs">
                Enterprise CIO · Board Candidate
              </span>
            </span>
          </Link>

          <nav aria-label="Sections" className="hidden items-center gap-1 xl:flex" data-id="element-72" data-mp="1dssryp62ahvh">
            {navigation.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `px-3 py-2 text-[12px] font-semibold uppercase tracking-[0.12em] transition-colors duration-150 ease-exec ${isActive ? 'text-copper-light' : 'text-panel/60 hover:text-panel'}`} data-id="element-73" data-mp="2k834jru8ruv3">
                {item.label}
              </NavLink>)}
          </nav>

          <button type="button" onClick={() => setOpen(v => !v)} className="flex items-center gap-2 border border-white/20 px-3 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-panel transition-colors duration-150 ease-exec hover:border-copper xl:hidden" aria-expanded={open} aria-controls="mobile-nav" data-id="element-74" data-mp="24in8grjne6zo">
            {open ? <XIcon className="h-4 w-4" data-id="element-75" data-mp="1ls5g4o2q9deu" /> : <MenuIcon className="h-4 w-4" data-id="element-76" data-mp="1lrx6d51wio7v" />}
            Sections
          </button>
        </div>

        {open ? <nav id="mobile-nav" aria-label="Sections" className="border-t border-white/10 bg-steel-dark px-5 pb-4 pt-2 sm:px-8 xl:hidden" data-id="element-77" data-mp="y19w4d4ijmi5">
            {navigation.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => `flex items-baseline gap-3 border-b border-white/5 py-3 text-sm font-semibold ${isActive ? 'text-copper-light' : 'text-panel/75'}`} data-id="element-78" data-mp="34qlbjyqvr8qg">
                <span className="tabular text-[11px] text-hydro-light" data-id="element-79" data-mp="3ni4a9tdvg0mo">{item.index}</span>
                {item.label}
              </NavLink>)}
          </nav> : null}
      </header>

      <main id="sheet" className="flex-1" data-id="element-80" data-mp="3ehg6rsm3tio1">
        {children}
      </main>

      <footer className="border-t border-white/10 bg-steel-dark" data-id="element-81" data-mp="3ejivm9bit5r6">
        <div className="mx-auto grid max-w-sheet gap-8 px-5 py-10 sm:px-8 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-82" data-mp="3ihgp3ocbqe0d">
          <div data-id="element-83" data-mp="230g7gd1ca3ki">
            <p className="display text-lg font-black text-panel" data-id="element-84" data-mp="23441reelyu0a">David Lukcic, P.E., MBA</p>
            <p className="mt-2 max-w-md text-sm leading-relaxed text-panel/65" data-id="element-85" data-mp="274xpa6o526sn">
              Enterprise technology leadership across three regulated operating companies — Tampa Electric,
              Peoples Gas, and New Mexico Gas.
            </p>
            <div className="mt-5 flex items-center gap-5 text-hydro-light" aria-hidden="true" data-id="element-86" data-mp="2dkehlea42c4m">
              <GridIcon className="h-6 w-6" data-id="element-87" data-mp="28md0gyw8wmvs" />
              <PipelineIcon className="h-6 w-6" data-id="element-88" data-mp="28no6l5d5y6q2" />
              <NeuralIcon className="h-6 w-6" data-id="element-89" data-mp="36a4zzzis006j" />
              <WaterIcon className="h-6 w-6" data-id="element-90" data-mp="368txs44zb0hj" />
            </div>
          </div>

          <div data-id="element-91" data-mp="31btq5oshdpob">
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-copper-light" data-id="element-92" data-mp="31bblq4vo055b">Direct</p>
            <ul className="mt-3 space-y-2 text-sm text-panel/75" data-id="element-93" data-mp="2wdiinkpnrr99">
              <li data-id="element-94" data-mp="2s92crjg1oju1">
                <a className="flex items-center gap-2 hover:text-panel" href={profile.phoneHref} data-id="element-95" data-mp="2s9khl4grw6dk">
                  <PhoneIcon className="h-4 w-4 text-hydro-light" data-id="element-96" data-mp="1kxlh8x0mvev5" /> {profile.phone}
                </a>
              </li>
              <li data-id="element-97" data-mp="1gx1kvvnvwfa2">
                <a className="flex items-center gap-2 hover:text-panel" href={`mailto:${profile.emails[0].address}`} data-id="element-98" data-mp="3siai7s15xfx9">
                  <MailIcon className="h-4 w-4 text-hydro-light" data-id="element-99" data-mp="dgdjr7s3ypw" /> {profile.emails[0].address}
                </a>
              </li>
              <li data-id="element-100" data-mp="5brok59t8f9p">
                <a className="flex items-center gap-2 hover:text-panel" href={profile.linkedIn} target="_blank" rel="noreferrer" data-id="element-101" data-mp="5b85umcc5mum">
                  <LinkedinIcon className="h-4 w-4 text-hydro-light" data-id="element-102" data-mp="k27axndypt9g" /> linkedin.com/in/davidlukcic
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-103" data-mp="o4lu68ljmv19">
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-copper-light" data-id="element-104" data-mp="o1zmm8ynkfj1">Operating Companies</p>
            <ul className="mt-3 space-y-2 text-sm text-panel/75" data-id="element-105" data-mp="2pvfe182kdyf2">
              {profile.companies.map(c => <li key={c.href} data-id="element-106" data-mp="2utgvjokcdpof">
                  <a className="hover:text-panel" href={c.href} target="_blank" rel="noreferrer" data-id="element-107" data-mp="2uuiiaqaq00lz">
                    {c.label}
                  </a>
                </li>)}
              <li data-id="element-108" data-mp="3t7e8y03glv45">{profile.location}</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/5 px-5 py-4 text-center text-[11px] uppercase tracking-[0.2em] text-panel/40 sm:px-8" data-id="element-109" data-mp="b1j4qukot38p">
          Board & Advisory Portfolio · Confidential Executive Summary
        </div>
      </footer>
    </div>;
}